import AbstractEditWidget from "cluetrainer/ui/widgets/AbstractEditWidget";
import jquery from "jquery";
import { ewent } from "../../reactive";
export default class TextField extends AbstractEditWidget {
    constructor(is_password = false) {
        super(jquery("<input class='nisl-textinput'>"));
        this.confirmed = ewent();
        this.setAttribute("type", is_password ? "password" : "text");
        this.container
            .val(this.get())
            .on("input", () => {
            this.preview(this.container.val());
        })
            .on("change", () => {
            this.commit(this.container.val());
        })
            .on("keydown", (e) => {
            if (e.key == "Enter") {
                this.confirmed.trigger(this.get());
            }
        });
    }
    setEnabled(v) {
        this.container.prop("disabled", !v);
        return this;
    }
    setPlaceholder(placeholder) {
        this.container.attr("placeholder", placeholder);
        return this;
    }
    onConfirm(f, handle = () => { }) {
        handle(this.confirmed.on(f));
        return this;
    }
    render() {
        this.container.val(this.get());
    }
}
